/**
 * Runs `fn` once the page has finished loading AND the browser is idle. Plain
 * requestIdleCallback is not enough: it also fires in the idle gaps while the
 * first screen is still waiting on the network, so a prefetch scheduled with it
 * competed with the very chunks the user was waiting for.
 */
export const afterLoadIdle = (fn: () => void): void => {
  const idle = () => {
    const ric = (window as any).requestIdleCallback as ((cb: () => void, opts?: { timeout: number }) => number) | undefined;
    if (ric) ric(fn, { timeout: 4000 });
    else setTimeout(fn, 1500);
  };
  if (document.readyState === "complete") idle();
  else window.addEventListener("load", idle, { once: true });
};
